//FG - FOOF - Jan 2 2019 - add into the array that is going to be displayed
    //  for the pool specific stuff.
    //
    //NOTE: at the time of writing there was only one value that is pool specific
    //      it is Bather Load.

    export const setupPoolSpecificRangeValues = (arrayToDisplay, oneSetOfRangeValues, aPool, allPools) => {
        //NOTE: location and facility are the same thing
        //      pool and venue are the same thing
  
        //The variable poolForThisMethod will hold onto the pool(venue) that needs
        //  to be displayed in the grid.  
        //If no pool tab has been chosen and the location (facility) has only
        //  one pool then that pool's values will be displayed
        //If no pool tab is chosen and there are multiple pools at the location
        //  then the pool specific info will not be displayed in the grid.
        //
        var poolForThisMethod = null;
        if(aPool=='') {
          if(allPools.length == 1) {
            poolForThisMethod = allPools[0]
          }
          else{
            poolForThisMethod = '';
          }
        }
        else {
          poolForThisMethod = aPool
        }
        if(poolForThisMethod == '')
          return;
  
        var poolSpecificValues = JSON.parse(JSON.stringify(oneSetOfRangeValues));
        poolSpecificValues.Name = oneSetOfRangeValues.Name;
  
        //Use the PoolSpecificHint to grab the pool specific value for the reading
        if(oneSetOfRangeValues.PoolSpecificHint=="BLT") {//Bather Load Total
          poolSpecificValues.Low = "0";
          poolSpecificValues.IdealLow = "0";
          poolSpecificValues.High = poolForThisMethod.PoolTotalMaxBathers;
          poolSpecificValues.IdealHigh = poolForThisMethod.PoolTotalMaxBathers;
          arrayToDisplay.push(poolSpecificValues)
          return;
        }
  
        if(oneSetOfRangeValues.PoolSpecificHint=="BLS") {//Bather Load Shallow
          poolSpecificValues.Low = "0";
          poolSpecificValues.IdealLow = "0";
          poolSpecificValues.High = poolForThisMethod.PoolShalowMaxBathers;
          poolSpecificValues.IdealHigh = poolForThisMethod.PoolShalowMaxBathers;
          arrayToDisplay.push(poolSpecificValues)
          return;
        }
        if(oneSetOfRangeValues.PoolSpecificHint=="BLD") {//Bather Load Deep
          poolSpecificValues.Low = "0";
          poolSpecificValues.IdealLow = "0";
          poolSpecificValues.High = poolForThisMethod.PoolDeepMaxBathers;
          poolSpecificValues.IdealHigh = poolForThisMethod.PoolDeepMaxBathers;
          arrayToDisplay.push(poolSpecificValues)
          return;
        }
        if(oneSetOfRangeValues.PoolSpecificHint=="TOT") {//Turn Over Time
          poolSpecificValues.Low = poolForThisMethod.PoolTurnOverTime_Min;
          poolSpecificValues.IdealLow = poolForThisMethod.PoolTurnOverTime;
          poolSpecificValues.High = poolForThisMethod.PoolTurnOverTime_Max;
          poolSpecificValues.IdealHigh = poolForThisMethod.PoolTurnOverTime;
          arrayToDisplay.push(poolSpecificValues)
          return;
        }
        if(oneSetOfRangeValues.PoolSpecificHint=="InP") {//Influent Pressure
          poolSpecificValues.Low = poolForThisMethod.PoolInfluentPressure_Min;
          poolSpecificValues.IdealLow = poolForThisMethod.PoolInfluentPressure;
          poolSpecificValues.High = poolForThisMethod.PoolInfluentPressure_Max;
          poolSpecificValues.IdealHigh = poolForThisMethod.PoolInfluentPressure;
          arrayToDisplay.push(poolSpecificValues)
          return;
        }
        if(oneSetOfRangeValues.PoolSpecificHint=="EfP") {//Efluent Pressure
          poolSpecificValues.Low = poolForThisMethod.PoolEfluentPressure_Min;
          poolSpecificValues.IdealLow = poolForThisMethod.PoolEfluentPressure;
          poolSpecificValues.High = poolForThisMethod.PoolEfluentPressure_Max;
          poolSpecificValues.IdealHigh = poolForThisMethod.PoolEfluentPressure;
          arrayToDisplay.push(poolSpecificValues)
          return;
        }
      }


// WEBPACK FOOTER //
// ./src/components/ReadingsMaintenance/readings_pool_specific_range_values.js